import React from "react"
import LoadingInput from "../../../../../../../_components/LoadingInput"

export default function Individual(props) {
  const handleChange = (e) => {
    props.onChange({
      name: e.target.name,
      value: e.target.value,
    })
  }

  return (
    <div className="row">
      <div className="col-md-3 col-xl-3">
        <LoadingInput
          label="Nome"
          type="text"
          name="name"
          value={props.name}
          onChange={handleChange}
          error={props.errors.name}
        />
      </div>
      <div  className="col-md-3 col-xl-3">
        <LoadingInput
          label="CPF"
          type="cpf"
          name="individual:cpf"
          value={props.cpf}
          onChange={handleChange}
          error={props.errors["individual:cpf"]}
        />
      </div>

      <div className="col-md-3 col-xl-3">
        <LoadingInput
          label="E-mail"
          type="email"
          name="email"
          value={props.email}
          onChange={handleChange}
          error={props.errors.email}
        />
      </div>
      <div className="col-md-3 col-xl-3">
        <LoadingInput
          label="Telefone"
          type="phone_number"
          name="phone_number"
          value={props.phone_number}
          onChange={handleChange}
          error={props.errors.phone_number}
        />
      </div>

      <div  className={`col-md-3 col-xl-3 ${ props.componenType == 4? "" : "d-none" }`}>
      <LoadingInput
          label="Inscrição Municipal"
          type="text"
          name="individual:municipal_registry"
          value={props.municipal_registry}
          onChange={handleChange}
          error={props.errors["individual:municipal_registry"]}
        />
      </div>

    </div>
  )
}



// WEBPACK FOOTER //
// ./src/views/AppViews/Branches/Branch/Create/components/Individual/index.jsx